module.exports = __webpack_public_path__ + "img/login-v2.35380730.svg";